var render, staticRenderFns
import script from "./DatasourceTable.vue?vue&type=script&lang=js"
export * from "./DatasourceTable.vue?vue&type=script&lang=js"
import style0 from "./DatasourceTable.vue?vue&type=style&index=0&id=e0b3ff64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_babel-core@7.0.0-bridge.0_@babel+core@7.29._a26fb9023b752f5df33ae8450879cd09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b3ff64",
  null
  
)

export default component.exports